/** Prefill and flow params that should not appear in shared links. */
const SHARE_STRIPPED_PARAMS = ['a', 'd', 'e', 'n', 'hide_lydia'] as const

/**
 * Returns a clean URL for sharing, without prefill or internal flow params.
 * Keeps identifiers such as `id` (money pot) or `t` (Lydia page).
 */
export const getShareUrl = (href: string = window.location.href): string => {
	const url = new URL(href)

	SHARE_STRIPPED_PARAMS.forEach((param) => {
		url.searchParams.delete(param)
	})

	return url.toString()
}
